import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const KAYO_MP4 = 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/514093d3-152b-449e-8ee5-6fa9d62a1d0a_kayo-wsy-post-Anna-Schriver.mp4?v=a5dd6208ed530f27758e1de92f7fd0a2';
const KAYO_THUMB = 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/8975b03f-5e87-4896-b316-fa9122432641_kayo-thumbnail-Anna-Schriver.jpg?v=6bb89026fac7eb2b72c63ee2cd1e9ef8';

export default function FeaturedWork() {
  const navigate = useNavigate();
  const [playing, setPlaying] = useState(false);

  const handleSeeAll = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/projects');
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
  };

  return (
    <section id="projects" className="pt-2 md:pt-10 pb-16 md:pb-20" style={{ background: '#0d0d0f' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          className="group relative cursor-pointer"
          style={{ aspectRatio: '16/9', overflow: 'hidden' }}
          onClick={() => { if (!playing) setPlaying(true); }}
        >
          {playing ? (
            <div className="absolute inset-0 w-full h-full" style={{ background: '#000' }}>
              <video
                src={KAYO_MP4}
                className="w-full h-full object-cover"
                autoPlay
                controls
                playsInline
              />
              <button
                className="absolute top-4 right-4 z-50 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200"
                style={{ background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(255,255,255,0.2)' }}
                onClick={(e) => { e.stopPropagation(); setPlaying(false); }}
              >
                <i className="ri-close-line text-white text-xl"></i>
              </button>
            </div>
          ) : (
            <>
              {/* Thumbnail — oversized by 4px on all sides to prevent edge bleed on scale */}
              <div
                className="absolute group-hover:scale-105 transition-transform duration-700"
                style={{ inset: '-4px', willChange: 'transform' }}
              >
                <img
                  src={KAYO_THUMB}
                  alt="KAYO — Social Edit"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* All overlays also use inset -4px so they cover the full bleed area */}
              {/* Black mist base */}
              <div
                className="absolute pointer-events-none"
                style={{
                  inset: '-4px',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.40) 35%, rgba(0,0,0,0.20) 65%, rgba(0,0,0,0.50) 100%)',
                }}
              />

              {/* Black mist smoky diffusion */}
              <div
                className="absolute pointer-events-none"
                style={{
                  inset: '-4px',
                  background: `
                    radial-gradient(ellipse 160% 80% at 50% 0%,   rgba(0,0,0,0.50) 0%, transparent 65%),
                    radial-gradient(ellipse 160% 80% at 50% 100%, rgba(0,0,0,0.55) 0%, transparent 65%),
                    radial-gradient(ellipse 80% 160% at 0%   50%, rgba(0,0,0,0.40) 0%, transparent 60%),
                    radial-gradient(ellipse 80% 160% at 100% 50%, rgba(0,0,0,0.40) 0%, transparent 60%)
                  `,
                }}
              />

              {/* Subtle film grain */}
              <div
                className="absolute pointer-events-none opacity-15"
                style={{
                  inset: '-4px',
                  backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'1\'/%3E%3C/svg%3E")',
                  backgroundSize: '128px 128px',
                  mixBlendMode: 'overlay',
                }}
              />

              {/* Play button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="w-20 h-20 flex items-center justify-center rounded-full opacity-80 group-hover:opacity-100 transition-all duration-500 group-hover:scale-110"
                  style={{ background: 'rgba(255,255,255,0.10)', border: '2px solid rgba(255,255,255,0.5)', backdropFilter: 'blur(4px)' }}
                >
                  <i className="ri-play-fill text-white text-3xl ml-1"></i>
                </div>
              </div>

              <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8">
                <h3 className="text-white uppercase mb-1" style={{ fontSize: 'clamp(1rem, 3vw, 2rem)', fontWeight: 900 }}>KAYO &mdash; Social Edit</h3>
                <p className="text-white/60 text-xs md:text-sm uppercase tracking-widest">Anna Schriver</p>
              </div>
            </>
          )}
        </div>

        <div className="mt-8 md:mt-10 flex justify-center">
          <a
            href="/projects"
            onClick={handleSeeAll}
            className="text-white text-sm font-bold tracking-widest uppercase border-b border-white/40 pb-1 hover:border-[#5b8ab5] hover:text-[#5b8ab5] transition-colors cursor-pointer"
          >
            SEE ALL PROJECTS
          </a>
        </div>
      </div>
    </section>
  );
}
